/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Start_TimesInputs */

const vi_irrigation_schedule_start_times = /** @type {(inputs: Irrigation_Schedule_Start_TimesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ bắt đầu`)
};

/**

* @param {Irrigation_Schedule_Start_TimesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_start_times = /** @type {((inputs?: Irrigation_Schedule_Start_TimesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Start_TimesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_start_times(inputs)
});